var SENTRY_RELEASE;SENTRY_RELEASE={name: "Durance", version: "0.1.0"};